// extracted by mini-css-extract-plugin
export default {"wrapper":"cookiesInfo_wrapper__bVr5E","logo":"cookiesInfo_logo__0gP+0","teamViewer":"cookiesInfo_teamViewer__NoUBL","itemWrapper":"cookiesInfo_itemWrapper__nKXZ0"};